import React, { useState, useEffect } from "react";
import { doGet } from "../services/api-service";
import { connect } from "react-redux";
import {getDataDoAssessment,getAssessmentDetail}  from "../actions";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import RefreshIcon from "@material-ui/icons/Refresh";
import DoneIcon from "@material-ui/icons/Done";
import PriorityHigh from "@material-ui/icons/PriorityHigh";
import Visibility from "@material-ui/icons/Visibility";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Grid from "@material-ui/core/Grid";
import Select from "react-select";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import ActionButton from "../components/ActionButton";
import InputIcon from "@material-ui/icons/Input";
import TableFooter  from "@material-ui/core/TableFooter";
import TablePagination   from "@material-ui/core/TablePagination";
import Tooltip   from "@material-ui/core/Tooltip";
import Search from "@material-ui/icons/Search";


const statusOptions = [{value:"all_employees",label:"Started"},
                            {value:"all_departments",label:"All Departments"},
                            {value:"one_employee",label:"One Employee"},
                            {value:"one_department",label:"One Department"}]

const PaMyAssessmentComponent = props => {
    const { classes } = props;

    const [dataTable, setDataTable] = useState([]);
    const [periodeOptions, setPeriodeOptions] = useState([])
    const [atasans, setAtasans] = useState([])
    
    const [selectedPeriode, setSelectedPeriode] = useState(null)
    
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [page, setPage] = useState(1)
    const [totalRows, setTotalRows] = useState(0)
    const [filterParams, setFilterParams] = useState({})

    const changePage=(event, newPage)=>{
        setPage(newPage+1)
        getData(newPage+1,filterParams)
    }

    const changeRowsPerPage = (event)=> {
        setRowsPerPage(+event.target.value);
        setPage(1);
    }

    const periodeOnChange = (e) =>{
        setSelectedPeriode(e)
    }

    useEffect(() => {
        getData(page,filterParams)
        getDataPeriode()
    }, []);

    useEffect(() => {
        getData(page,filterParams)
    }, [rowsPerPage])


    const btnRefresh = ()=>{
        getData(page,filterParams)
    }

    const getDataPeriode = async () =>{
        const params={}
        const response = await doGet("pa/assessment/periodes",params)
        if(response&&response.data&&response.data.length>0){
            const dataForSelect = response.data.map(periode=>({value:periode, label:periode}))
            setPeriodeOptions(dataForSelect)
        }

    }

    const getData = async (toPage, filterParams) =>{
        let params={
            page:toPage,
            rowsPerPage:rowsPerPage,
            user_id: props.user.emp_id
        }

        if(filterParams)
        params = {...params, ...filterParams}

        const response = await doGet(
            "pa/assessment/my",
            params
        );
        if(response && response.data){
            setDataTable(response.data.data)
            setPage(response.data.meta.current_page)
            setTotalRows(response.data.meta.total)
        } 
    };

    const doAssessment = $assessmentUserId => {
        props.getDataDoAssessment($assessmentUserId)
        props.history.push("/pa/app/assessment/do");
    };

    const DoneAction = ({user_id, row})=>{

        const atasans =  row.atasan_id.split(',');
        const fill_atasans =  row.fill_by_nik_atasan.split(',');

        const atasan_id = atasans.find(obj => {
            return obj === user_id.toString();
        });

        const fill_atasan_id = fill_atasans.find(obj => {
            return obj === user_id.toString();
        });


        // console.log(atasan_id)
        // console.log(row)
        // console.log(user_id)
        // console.log("ATASAN", atasan_id+' '+user_id+' FILL '+row.fill_by_atasan)

        console.log("user_id", user_id)
        console.log("atasan_id", atasan_id)

        console.log("fill_atasan_id", fill_atasan_id)
        console.log("row.owner", row.owner)

        console.log("row", row)

        // user_id == atasan_id && row.fill_by_atasan == 1 X
        // user_id == fill_atasan_id == user_id OK
        //user_id == row.owner && row.fill_by_staff == 1 x

        // if(row.status_value==='Finish'){
        //     return (
        //                     <ActionButton
        //                     title="detail"
        //                     type="icon-button"
        //                     for={["usr","adm","ldr"]}
        //                     role={props.user.role}
        //                     action={() =>goToDetail(row.id)}
        //                     disabled={row.status === 0}
        //                     icon={<Visibility fontSize="small" />}
        //                 />
        //     )


        if( user_id == atasan_id && row.fill_by_atasan == 1 || 
            fill_atasan_id == user_id ||
            user_id == row.owner && row.fill_by_staff == 1 ||
            (user_id === row.owner && row.status_value.includes('Expired'))||
            row.status_value.toLowerCase().includes('disagree')  // TAMBAH INI
        ){
            return (
                    <ActionButton
                    title="detail"
                    type="icon-button"
                    for={["usr","adm","ldr"]}
                    role={props.user.role}
                    action={() =>goToDetail(row.id)}
                    disabled={row.status === 0}
                    icon={<Visibility fontSize="small" />}
                />
                
            )
        }else{
            return(
                <ActionButton
                    title="enter"
                    type="icon-button"
                    for={["usr", "adm","ldr"]}
                    role={props.user.role}
                    action={() =>doAssessment(row.id)}
                    disabled={row.active === 0 || row.status_value==="expired"}
                    icon={<InputIcon fontSize="small" />}
                />
            )
        }
    }

    const ApprovalStatus = ({approval})=>{

        if(approval===1){
            return(
                <Tooltip title="approved by staff">
                    <DoneIcon fontSize="small" color="primary"/>
                </Tooltip>
            )
        }else if(approval===2){
            return(
                <Tooltip title="rejected by staff">
                    <PriorityHigh fontSize="small" color="secondary"/>
                </Tooltip>
            )
        }else{
            return null
        }

    }

    const goToDetail = (assessment_user_id) =>{
        props.getAssessmentDetail(assessment_user_id)
        props.history.push("/pa/app/assessment/detail")
    }

    const filter = async () => {
        const params = {
            periode : selectedPeriode!==null ? selectedPeriode.value : null
        };
        setFilterParams(params)
        getData(page,params)
    };

    const [isDialogOpen, setDialogOpen] = useState(false);

    const handleCellClick = async (row) => {

        setAtasans(row.atasan_ids)

        setDialogOpen(true);

        // let params={
        //     id:row.id,
        //     atasan_id: row.atasan_id
        // }

        // const response = await doGet(
        //     "pa/assessment/evaluator",
        //     params
        // );
        // if(response && response.data){

        //     if(response.data.message=='available'){
        //         setAtasans(response.data.data)
        //     }else{
        //         setAtasans(response.data.data)
        //     }

        //     setDialogOpen(true);
            
        // } 
       
    };

    const handleCloseDialog = () => {
        setDialogOpen(false);
    };

    return (
        <React.Fragment>

            <Grid
                container
                spacing={8}
                direction="column"
                className={classes.container}
            >
                <Grid container direction="row" alignContent="flex-start">
                    <Grid item xs={10}>
                        <Typography
                            variant="h6"
                            gutterBottom
                            className="animated slideInLeft"
                        >
                            Assessment List
                        </Typography>
                    </Grid>

                    <Grid item  xs={2} align="right">
                        <ActionButton
                             type="fab"
                             title="refresh"
                             for={["adm","usr","ldr"]}
                             role={props.user.role}
                             action={btnRefresh}
                             icon={<RefreshIcon />}
                             class={classes.fab}/>

                    </Grid>


                    <Grid container spacing={8} className={classes.filterContainer} >
                        <Grid item spacing={8} xs={9}container>
                         
              
                            <Grid item xs={4}>
                                <Select
                                    options={periodeOptions}
                                    value={selectedPeriode}
                                    onChange={periodeOnChange}
                                    placeholder="Select periode"
                                    isClearable
                                />
                            </Grid>


                        </Grid>
        

                        <Grid item xs={2} container justify="flex-end" alignItems="baseline">
                            <IconButton  onClick={filter} color="primary" aria-label="search">
                                <Search />
                            </IconButton>

                        </Grid>
                    </Grid>


                    <Grid item xs={12} className={classes.tableWrapper}>
                        <div className={classes.table}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">
                                            Owner
                                        </TableCell>
                                        <TableCell align="center">
                                            Assessment
                                        </TableCell>
                                        <TableCell align="center">
                                            Valid From
                                        </TableCell>
                                        <TableCell align="center">
                                            Valid Until
                                        </TableCell>
                                        <TableCell align="center">
                                            Status
                                        </TableCell>
                                        <TableCell align="center">
                                            total score
                                        </TableCell>
                                        <TableCell align="center">
                                           ...
                                        </TableCell>
                                        <TableCell align="center"></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {dataTable.length > 0 &&
                                        dataTable.map(row => (
                                            <TableRow key={row.id}>
                                                <TableCell align="left" >
                                                    {row.owner_name}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {row.master_name}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {row.valid_from}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {row.valid_until}
                                                </TableCell>
                                                <TableCell align="center" onClick={() => handleCellClick(row)}>
                                                    <span  style={{ cursor: 'pointer', color: 'blue' }}>
                                                    {row.status_value}
                                                    </span>
                                                </TableCell>
                                                <TableCell align="center">
                                                    {row.total_score}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {row.active==1? 'Active' : 'Inactive'}
                                                </TableCell>
                                                <TableCell align="center">
                                                    <Grid wrap="nowrap" container alignItems="center">
                                                        <ApprovalStatus approval={row.approval_staff}/>
                                                        {props.user &&
                                                        <DoneAction
                                                            user_id = {props.user.emp_id}
                                                            row = {row}
                                                        />

                                                       
                                                        }

                                                        {/* {row.fill_by_atasan}
                                                        {row.fill_by_staff} */}
                                                    </Grid>
                                                </TableCell>
                                                
                                            </TableRow>
                                        ))}
                                </TableBody>

                                <TableFooter>
                                    <tr>
                                        <td colspan="5">
                                            <Grid container justify="flex-end">
                                                <Grid item>
                                                <TablePagination
                                                    rowsPerPageOptions={[5, 10, 25]}
                                                    component="div"
                                                    count={totalRows}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page-1}
                                                    backIconButtonProps={{
                                                        "aria-label": "previous page",
                                                    }}
                                                    nextIconButtonProps={{
                                                        "aria-label": "next page",
                                                    }}
                                                    onChangePage={changePage}
                                                    onChangeRowsPerPage={changeRowsPerPage}
                                                />
                                                </Grid>
                                            </Grid>
                                        </td>
                                    </tr>

                                </TableFooter>
                            </Table>
                        </div>
                    </Grid>
                </Grid>
            </Grid>


             {/* Dialog */}
             <Dialog
                open={isDialogOpen}
                onClose={handleCloseDialog}
                PaperProps={{
                style: {
                    alignItems: 'center',
                    justifyContent: 'center',
                    display: 'flex',
                    minWidth: '50%',
                },
                }}
            >   
                {atasans && atasans.length > 0 ? (
                <DialogTitle>Daftar Yang Menilai</DialogTitle>
                  ):''}
              
                <DialogContent>
            
                {atasans && atasans.length > 0 ? (
                <Table>
                    <TableHead>
                    <TableRow>
                        <TableCell><b>NIK</b></TableCell>
                        <TableCell><b>NAMA</b></TableCell>
                        <TableCell><b>SUDAH MENILAI</b></TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                    {atasans.map((row) => (
                        <TableRow key={row.emp_id}>
                        <TableCell>{row.emp_id}</TableCell>
                        <TableCell>{row.emp_name}</TableCell>
                        <TableCell>{row.sudah_menilai ? 'Sudah':'Belum'}</TableCell>
                        </TableRow>
                    ))}
                    </TableBody>
                </Table>
                ) : (
                <DialogTitle>Belum ada atasan yang menilai</DialogTitle>
                )}
                </DialogContent>
                <DialogActions>
                <Button onClick={handleCloseDialog} color="primary">
                    Close
                </Button>
                </DialogActions>
            </Dialog>


        </React.Fragment>
    );
};



const styles = theme => ({
    button_mini: {
        width: 30,
        height: 30,
        padding: 0
    },
    selectFilter: {
        marginTop: 5
    },
    container: {
        margin: -16
    },
    widthAction: {
        minWidth: 180
    },
    widthDate: {
        minWidth: 150
    },
    switchIcon: {
        height: 10,
        width: 10,
        color: "#ffffff"
    },
    fab: {
        marginTop: -30
    },
    tableWrapper: {
        
    },
    table: {
        border: "solid 1px RGB(204, 204, 204)",
        borderRadius: 5,
        display: "inline-block",
        width: "-webkit-fill-available",
        overflowX: "auto"
    }
});
const mapDispatchToProps = dispatch => {
    return {
        getDataDoAssessment : data => dispatch(getDataDoAssessment(data)),
        getAssessmentDetail : data => dispatch(getAssessmentDetail(data)),

    };
  }

const mapStateToProps = state => {
    return {
        user: state.user.user
    };
};

const PaMasterCreate = connect(mapStateToProps,mapDispatchToProps)(PaMyAssessmentComponent);
export default withRouter(withStyles(styles)(PaMasterCreate));


